module.exports = __webpack_public_path__ + "static/media/chat_close.e7dd64c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_close.png
// module id = 403
// module chunks = 0